import { useTranslation } from 'react-i18next';
import { useGetCalculatorOfferingQuery } from '@app/api/calculatorApi';
import QuestionIcon from '@app/components/icons/QuestionIcon';
import getMinMaxPeriodAndAmount from '@modules/calculator/utils/getMinMaxTermAndAmount';
const FormTooltip = ({ name }) => {
    const { t } = useTranslation();
    const { data: offeringData } = useGetCalculatorOfferingQuery();
    const minMaxValues = offeringData ? getMinMaxPeriodAndAmount(offeringData) : null;
    const getTooltipText = (fieldName) => {
        if (!minMaxValues) {
            return null;
        }
        switch (fieldName) {
            case 'credit_amount':
                return t('financing.solvency_declaration.credit_amount_tooltip', {
                    minAmount: minMaxValues.minAmount,
                    maxAmount: minMaxValues.maxAmount,
                });
            case 'credit_period':
                return t('financing.solvency_declaration.credit_period_tooltip', {
                    minPeriod: minMaxValues.minPeriod,
                    maxPeriod: minMaxValues.maxPeriod,
                });
            default:
                return null;
        }
    };
    const tooltipText = getTooltipText(name);
    if (!tooltipText) {
        return null;
    }
    return (<div className="flex items-start gap-1.5 mt-1">
            <QuestionIcon className="text-neutral-secondary-initial shrink-0 mt-0.5"/>
            <span className="body-s text-neutral-secondary-initial">{tooltipText}</span>
        </div>);
};
export default FormTooltip;
